<template>
  <div
    class="signin-page"
    role="main"
    aria-label="Tela de acesso ao Sistema Clin"
  >
    <!--
      Ícones de saúde decorativos no fundo.
      aria-hidden="true" → invisíveis para leitores de tela.
      pointer-events: none → não capturam cliques/touch.
      Cada ícone tem posição, rotação e opacidade próprias para
      evitar padrão repetitivo (efeito wallpaper).
    -->
    <svg
      class="signin-page__bg-icons"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 900"
      preserveAspectRatio="xMidYMid slice"
    >
      <!-- Cruz grande — topo direito -->
      <g transform="translate(1270,60) rotate(15)" opacity="0.07">
        <rect x="-8" y="-28" width="16" height="56" rx="4" fill="white" />
        <rect x="-28" y="-8" width="56" height="16" rx="4" fill="white" />
      </g>

      <!-- Prancheta — meio esquerdo -->
      <g transform="translate(55,340) rotate(-8)" opacity="0.06">
        <rect
          x="0"
          y="8"
          width="44"
          height="54"
          rx="4"
          fill="none"
          stroke="white"
          stroke-width="2.5"
        />
        <rect x="14" y="2" width="16" height="12" rx="3" fill="white" />
        <line
          x1="8"
          y1="26"
          x2="36"
          y2="26"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="8"
          y1="34"
          x2="36"
          y2="34"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="8"
          y1="42"
          x2="28"
          y2="42"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>

      <!-- Pílula/cápsula — topo esquerdo -->
      <g transform="translate(80,100) rotate(-30)" opacity="0.06">
        <rect
          x="0"
          y="0"
          width="52"
          height="22"
          rx="11"
          fill="none"
          stroke="white"
          stroke-width="2.5"
        />
        <line x1="26" y1="0" x2="26" y2="22" stroke="white" stroke-width="2" />
        <rect
          x="0"
          y="0"
          width="26"
          height="22"
          rx="11"
          fill="white"
          opacity="0.2"
        />
      </g>

      <!-- Estetoscópio — inferior direito -->
      <g transform="translate(1180,610) rotate(10)" opacity="0.055">
        <circle
          cx="20"
          cy="10"
          r="12"
          fill="none"
          stroke="white"
          stroke-width="2.5"
        />
        <path
          d="M10 20 Q-4 40 10 58 Q24 72 24 88"
          fill="none"
          stroke="white"
          stroke-width="2.5"
          stroke-linecap="round"
        />
        <circle
          cx="24"
          cy="96"
          r="8"
          fill="none"
          stroke="white"
          stroke-width="2.5"
        />
      </g>

      <!-- Cruz pequena — meio direito -->
      <g transform="translate(1350,430) rotate(-10)" opacity="0.05">
        <rect x="-5" y="-18" width="10" height="36" rx="3" fill="white" />
        <rect x="-18" y="-5" width="36" height="10" rx="3" fill="white" />
      </g>

      <!-- Seringa — inferior esquerdo -->
      <g transform="translate(30,640) rotate(20)" opacity="0.06">
        <rect
          x="12"
          y="0"
          width="32"
          height="14"
          rx="3"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <line
          x1="28"
          y1="14"
          x2="28"
          y2="32"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
        />
        <line x1="23" y1="32" x2="33" y2="32" stroke="white" stroke-width="2" />
        <line
          x1="28"
          y1="32"
          x2="28"
          y2="42"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="0"
          y1="7"
          x2="12"
          y2="7"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>

      <!-- Assinatura/rubrica — topo centro -->
      <g transform="translate(600,28) rotate(-5)" opacity="0.05">
        <path
          d="M0 28 C10 8,24 0,34 12 C44 24,34 42,48 36 C62 28,68 14,78 18"
          fill="none"
          stroke="white"
          stroke-width="2.5"
          stroke-linecap="round"
        />
        <line
          x1="10"
          y1="42"
          x2="72"
          y2="42"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          opacity="0.6"
        />
      </g>

      <!-- Coração — inferior centro-direito -->
      <g transform="translate(920,730) rotate(-8)" opacity="0.055">
        <path
          d="M24 44 C24 44,0 28,0 14 C0 5,7 0,14 0 C19 0,24 5,24 5 C24 5,29 0,34 0 C41 0,48 5,48 14 C48 28,24 44,24 44Z"
          fill="white"
        />
      </g>

      <!-- Pílula pequena — direito superior -->
      <g transform="translate(1120,240) rotate(45)" opacity="0.045">
        <rect
          x="0"
          y="0"
          width="38"
          height="17"
          rx="8"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <line
          x1="19"
          y1="0"
          x2="19"
          y2="17"
          stroke="white"
          stroke-width="1.5"
        />
      </g>

      <!-- Termômetro — esquerdo inferior-médio -->
      <g transform="translate(190,530) rotate(-15)" opacity="0.05">
        <rect
          x="8"
          y="0"
          width="14"
          height="44"
          rx="7"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <circle
          cx="15"
          cy="56"
          r="10"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <rect
          x="11"
          y="22"
          width="8"
          height="24"
          rx="4"
          fill="white"
          opacity="0.4"
        />
      </g>

      <!-- Cruz grande — inferior esquerdo (parcialmente cortada pela borda) -->
      <g transform="translate(-10,780) rotate(5)" opacity="0.04">
        <rect x="-10" y="-40" width="20" height="80" rx="5" fill="white" />
        <rect x="-40" y="-10" width="80" height="20" rx="5" fill="white" />
      </g>

      <!-- Prancheta pequena — topo direito médio -->
      <g transform="translate(850,18) rotate(12)" opacity="0.045">
        <rect
          x="0"
          y="7"
          width="34"
          height="44"
          rx="3"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <rect x="11" y="1" width="12" height="10" rx="2" fill="white" />
        <line
          x1="7"
          y1="22"
          x2="27"
          y2="22"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="7"
          y1="30"
          x2="27"
          y2="30"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </g>
    </svg>

    <!-- Container principal do formulário -->
    <b-container fluid class="form-signin signin signin-page__card">
      <confirmation-dialog
        hide-open-button
        message-title="Você já está logado"
        message-body="Tem certeza que deseja sair?"
        v-model="showLogoutDialog"
        @yes="logout"
        @no="$router.push({ name: 'dashboard' })"
      />

      <b-row align-h="center" no-gutters>
        <b-col sm="12" md="12" lg="12" xl="12">
          <b-row>
            <b-col cols="12" class="mt-0 pt-0">
              <img
                id="logo"
                src="https://sistemclinupload.s3.amazonaws.com/logo.png"
                alt="Sistema Clin — Software para ILPI, casas de repouso e clínicas"
              />
            </b-col>

            <b-col cols="12" class="mt-0 pt-0">
              <verify-email
                v-if="showVerifyEmail"
                @success="evOnVerifyEmailSuccess"
              />
              <online-sign-in
                v-if="showOnlineSignIn"
                :clients="clients"
                :email="email"
                @return="reset"
              />
              <offline-sign-in
                v-if="showOfflineSignIn"
                :user="user"
                @return="reset"
              />
            </b-col>
          </b-row>

          <b-row align-h="center" v-if="device_code()">
            <b-col cols="auto" class="mt-0 pt-0">
              <small class="signin-page__device-code">
                DISPOSITIVO: <span>{{ device_code() }}</span>
              </small>
            </b-col>
          </b-row>

          <div class="signin-alert-device">
            <p class="worksansr m-0 text-center">
              Acesse o sistema no Google Chrome.
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import VerifyEmail from "../templates/SignIn/VerifyEmail.vue";
import OnlineSignIn from "../templates/SignIn/OnlineSignIn.vue";
import OfflineSignIn from "../templates/SignIn/OfflineSignIn.vue";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog.vue";
import api from "../services/api";

export default {
  name: "SignIn",

  components: {
    VerifyEmail,
    OnlineSignIn,
    OfflineSignIn,
    ConfirmationDialog,
  },

  data() {
    return {
      showLogoutDialog: false,
      showVerifyEmail: false,
      showOnlineSignIn: false,
      showOfflineSignIn: false,
      offline: false,
      email: "",
      cpf: "",
      clients: [],
      user: undefined,
    };
  },

  mounted() {
    this.showLogoutDialog = false;
    this.showVerifyEmail = false;
    this.showOnlineSignIn = false;
    this.showOfflineSignIn = false;
    this.offline = false;
    this.email = "";
    this.clients = [];
    this.user = undefined;

    this.isLoggedIn();
  },

  methods: {
    device_code() {
      return localStorage.getItem("device_code");
    },

    async isLoggedIn() {
      try {
        const response = await api.get("/status/logged-in");
        const { error, logged_in } = response.data;

        const session = ["rest_home_id", "user", "permissions"].every((key) =>
          sessionStorage.getItem(key)
        );

        if (!error && logged_in && session) {
          this.showLogoutDialog = true;
        } else {
          await this.logout();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async logout() {
      try {
        await api.get("/status/logout");
        this.showVerifyEmail = true;
      } catch (error) {
        console.log(error);
      }
    },

    async reset() {
      this.showVerifyEmail = true;
      this.showOnlineSignIn = false;
      this.showOfflineSignIn = false;
      this.email = "";
      this.clients = [];
      this.offline = false;
    },

    async evOnVerifyEmailSuccess(event) {
      const { offline, clients, email, user } = event;

      this.showVerifyEmail = false;
      this.showOnlineSignIn = !offline;
      this.showOfflineSignIn = offline;

      this.offline = offline;
      this.clients = clients;
      this.email = email;
      this.user = user;
    },
  },
};
</script>

<style scoped>
.signin-page {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #0F65B0 0%, #0F65B0 55%, #0F65B0 100%);
  overflow: hidden;
  z-index: 0;
}

/*
  SVG ocupa toda a área do .signin-page.
  Os ícones usam coordenadas em % então se adaptam
  a qualquer resolução de tela automaticamente.
*/
.signin-page__bg-icons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.signin-page__card.form-signin {
  position: relative;
  z-index: 1;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.28), 0 2px 8px rgba(0, 0, 0, 0.16);
  padding-bottom: 8px;
}

#logo {
  display: block;
  padding: 24px 32px 12px;
  width: 100%;
  height: auto;
  max-width: 300px;
  margin: 0 auto;
}

.signin-page__device-code {
  font-size: 11px;
  color: #888;
  letter-spacing: 0.03em;
}
</style>